import React from "react";
import {formatLongDate, formatNumber, isActive, isLowWork, isUnavailable} from "../../util";

const ProjectCard = ({project}) => {
    let operatedBy = `Operated by ${project.home}`
    if ( project.home === undefined || project.home === null || project.home === '' || project.home === 'Independent') {
        operatedBy = undefined
    }
    let lastNews = ''
    if (Date.parse(project.lastNews) > 0) {
        lastNews = <div className="card-subtitle project-item-card-subtitle text-muted">Last news article: {formatLongDate(Date.parse(project.lastNews))}</div>
    }

    let activeUsers = ''
    if((isActive(project) || isLowWork(project)) && project.numActiveUsers>0) {
        activeUsers = <div className="card-subtitle project-item-card-subtitle text-muted">Active users: {formatNumber(project.numActiveUsers)}</div>
    }

    let activeHosts = ''
    if((isActive(project) || isLowWork(project)) && project.numActiveHosts>0) {
        activeHosts = <div className="card-subtitle project-item-card-subtitle text-muted">Active hosts: {formatNumber(project.numActiveHosts)}</div>
    }

    let jobsAvailable = ''
    if(project.hasServerStatusPage && (isActive(project) || isLowWork(project))) {
        jobsAvailable = <div className="card-subtitle project-item-card-subtitle text-muted">Jobs available: {formatNumber(project.resultsReadyToSend)}</div>
    }

    let link = ''
    let scheduler = ''
    if(!isUnavailable(project)) {
        link = <a className="btn btn-primary btn-sm mb-3" href={project.url}>Visit website</a>
        const schedulerMS = Date.parse(project.lastSchedulerOnline) + 2*60*1000
        const successMS = Date.parse(project.lastSuccess)
        if (schedulerMS > successMS) {
            scheduler = <div className="card-subtitle project-item-card-subtitle text-muted">Scheduler is <span className="text-success">online</span></div>
        } else {
            scheduler = <div className="card-subtitle project-item-card-subtitle text-muted">Scheduler is <span className="text-danger">offline</span></div>
        }
    }

    return (
        <div className="col-12 col-lg-6">
            <div className="card project-item-card shadow-sm">
                <div className="card-body project-item-card-body">
                    <h5 className="card-title mb-2">{project.name}</h5>
                    <div className="border-top w-100"/>
                    <p className="card-text project-card-text mt-2 mb-3">{project.description}</p>
                    {link}
                    {operatedBy && (<div className="card-subtitle project-item-card-subtitle text-muted mb-2">{operatedBy}</div>)}
                    {scheduler}
                    {activeUsers}
                    {activeHosts}
                    {jobsAvailable}
                    {lastNews}
                </div>
            </div>
        </div>
    )
}

export default ProjectCard
